import Header from "./Components/Technology/Header"
import CTA from "./Components/CTA"
import MobileEngineering from "./Components/Technology/MobileEngineering"
import WebEngineering from "./Components/Technology/WebEngineering"
import SaasEngineering from "./Components/Technology/SaasEngineering"

const Technology = () => {
    return (
        <div className="select-none">
            <Header></Header>
            <MobileEngineering></MobileEngineering>
            <WebEngineering></WebEngineering>
            <SaasEngineering></SaasEngineering>
            <CTA></CTA>
        </div>
    )
}

export default Technology